// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./Pretendard-Bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./Pretendard-Medium.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./Pretendard-Regular.woff2", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
Copyright (c) 2021 Kil Hyung-jin, with Reserved Font Name Pretendard.
https://github.com/orioncactus/pretendard

This Font Software is licensed under the SIL Open Font License, Version 1.1.
This license is copied below, and is also available with a FAQ at:
http://scripts.sil.org/OFL
*/

/* @font-face {
	font-family: 'Pretendard';
	font-weight: 900;
	font-display: swap;
	src: local('Pretendard Black'), url('./font/Pretendard-Black.woff2') format('woff2'), url('./woff/Pretendard-Black.woff') format('woff');
}

@font-face {
	font-family: 'Pretendard';
	font-weight: 800;
	font-display: swap;
	src: local('Pretendard ExtraBold'), url('./font/Pretendard-ExtraBold.woff2') format('woff2'), url('./woff/Pretendard-ExtraBold.woff') format('woff');
} */

@font-face {
	font-family: 'Pretendard';
	font-weight: 700;
	font-display: swap;
	src: local('Pretendard Bold'), url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff2');
}

/* @font-face {
	font-family: 'Pretendard';
	font-weight: 600;
	font-display: swap;
	src: local('Pretendard SemiBold'), url('./font/Pretendard-SemiBold.woff2') format('woff2'), url('./woff/Pretendard-SemiBold.woff') format('woff');
} */

@font-face {
	font-family: 'Pretendard';
	font-weight: 500;
	font-display: swap;
	src: local('Pretendard Medium'), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff2');
}

@font-face {
	font-family: 'Pretendard';
	font-weight: 400;
	font-display: swap;
	src: local('Pretendard Regular'), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('woff2');
}

/* @font-face {
	font-family: 'Pretendard';
	font-weight: 300;
	font-display: swap;
	src: local('Pretendard Light'), url('./font/Pretendard-Light.woff2') format('woff2'), url('./woff/Pretendard-Light.woff') format('woff');
} */

/* @font-face {
	font-family: 'Pretendard';
	font-weight: 200;
	font-display: swap;
	src: local('Pretendard ExtraLight'), url('./font/Pretendard-ExtraLight.woff2') format('woff2'), url('./woff/Pretendard-ExtraLight.woff') format('woff');
} */

/* @font-face {
	font-family: 'Pretendard';
	font-weight: 100;
	font-display: swap;
	src: local('Pretendard Thin'), url('./font/Pretendard-Thin.woff2') format('woff2'), url('./woff/Pretendard-Thin.woff') format('woff');
} */
`, "",{"version":3,"sources":["webpack://./src/css/font/pretendard.css"],"names":[],"mappings":"AAAA;;;;;;;CAOC;;AAED;;;;;;;;;;;;GAYG;;AAEH;CACC,yBAAyB;CACzB,gBAAgB;CAChB,kBAAkB;CAClB,sFAA6E;AAC9E;;AAEA;;;;;GAKG;;AAEH;CACC,yBAAyB;CACzB,gBAAgB;CAChB,kBAAkB;CAClB,wFAAiF;AAClF;;AAEA;CACC,yBAAyB;CACzB,gBAAgB;CAChB,kBAAkB;CAClB,yFAAmF;AACpF;;AAEA;;;;;GAKG;;AAEH;;;;;GAKG;;AAEH;;;;;GAKG","sourcesContent":["/*\nCopyright (c) 2021 Kil Hyung-jin, with Reserved Font Name Pretendard.\nhttps://github.com/orioncactus/pretendard\n\nThis Font Software is licensed under the SIL Open Font License, Version 1.1.\nThis license is copied below, and is also available with a FAQ at:\nhttp://scripts.sil.org/OFL\n*/\n\n/* @font-face {\n\tfont-family: 'Pretendard';\n\tfont-weight: 900;\n\tfont-display: swap;\n\tsrc: local('Pretendard Black'), url('./font/Pretendard-Black.woff2') format('woff2'), url('./woff/Pretendard-Black.woff') format('woff');\n}\n\n@font-face {\n\tfont-family: 'Pretendard';\n\tfont-weight: 800;\n\tfont-display: swap;\n\tsrc: local('Pretendard ExtraBold'), url('./font/Pretendard-ExtraBold.woff2') format('woff2'), url('./woff/Pretendard-ExtraBold.woff') format('woff');\n} */\n\n@font-face {\n\tfont-family: 'Pretendard';\n\tfont-weight: 700;\n\tfont-display: swap;\n\tsrc: local('Pretendard Bold'), url('./Pretendard-Bold.woff2') format('woff2');\n}\n\n/* @font-face {\n\tfont-family: 'Pretendard';\n\tfont-weight: 600;\n\tfont-display: swap;\n\tsrc: local('Pretendard SemiBold'), url('./font/Pretendard-SemiBold.woff2') format('woff2'), url('./woff/Pretendard-SemiBold.woff') format('woff');\n} */\n\n@font-face {\n\tfont-family: 'Pretendard';\n\tfont-weight: 500;\n\tfont-display: swap;\n\tsrc: local('Pretendard Medium'), url('./Pretendard-Medium.woff2') format('woff2');\n}\n\n@font-face {\n\tfont-family: 'Pretendard';\n\tfont-weight: 400;\n\tfont-display: swap;\n\tsrc: local('Pretendard Regular'), url('./Pretendard-Regular.woff2') format('woff2');\n}\n\n/* @font-face {\n\tfont-family: 'Pretendard';\n\tfont-weight: 300;\n\tfont-display: swap;\n\tsrc: local('Pretendard Light'), url('./font/Pretendard-Light.woff2') format('woff2'), url('./woff/Pretendard-Light.woff') format('woff');\n} */\n\n/* @font-face {\n\tfont-family: 'Pretendard';\n\tfont-weight: 200;\n\tfont-display: swap;\n\tsrc: local('Pretendard ExtraLight'), url('./font/Pretendard-ExtraLight.woff2') format('woff2'), url('./woff/Pretendard-ExtraLight.woff') format('woff');\n} */\n\n/* @font-face {\n\tfont-family: 'Pretendard';\n\tfont-weight: 100;\n\tfont-display: swap;\n\tsrc: local('Pretendard Thin'), url('./font/Pretendard-Thin.woff2') format('woff2'), url('./woff/Pretendard-Thin.woff') format('woff');\n} */\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
